import {useContext} from 'react'
import {CouponCodeReportContext} from '../../context'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import {COUPON_CODE_REPORT_COLUMNS} from '../../utils'
import CouponCodeReportRow from './CouponCodeReportRow'
import {parseCouponCodeReportRow} from '../../parsings'

const CouponCodeReportTable = () => {
  const {reportData, isLoading, filters, onSortingChange, pagination, onPageChange} =
    useContext(CouponCodeReportContext)

  return (
    <DynamicTable
      data={reportData}
      sortableColumns={COUPON_CODE_REPORT_COLUMNS}
      loading={isLoading}
      TableRow={CouponCodeReportRow}
      noDataMessage='No coupon code reports found'
      onSortingChange={onSortingChange}
      filters={filters}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      pagination={pagination}
      onPageChange={onPageChange}
      rowParsingFunction={parseCouponCodeReportRow}
    />
  )
}

export default CouponCodeReportTable
